module.exports = __webpack_public_path__ + "static/backroom-0f003e8cd6ef94e3aab0eafbaf4636d4.jpg";